import React, { useState, useEffect } from 'react';
import { Col, Row } from 'antd';
import ExamesIcon from '../assets/iconExames.png';
import {
  ArrowLeftOutlined,
  FilterOutlined
} from '@ant-design/icons';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import './CadastrarExames.scss';
import { useNavigate } from 'react-router-dom'
import { getDoencas, getNutrientes, getExames, getExameFaixaEtaria, createDiagnostico, createRegistroExame, getRegistroExames } from '../service/api';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import CircularProgress from '@mui/material/CircularProgress';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  backgroundColor: '#ebebeb',
  color: '#555555',
  boxShadow: 24,
  p: 4,
};

const CadastrarExames = () => {
  let navigate = useNavigate();
  const [doencaSaved, setDoencaSaved] = useState({})
  const [realizouCadastroDoenca, setRealizouCadastroDoenca] = useState(false)
  const [nutrientesSaved, setNutrientesSaved] = useState([])
  const [doeancasList, setDoeancasList] = useState([])
  const [nutrientesList, setNutrientesList] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [openModalExames, setOpenModalExames] = useState(false)
  const [doenca, setDoenca] = useState({});
  const [description, setDescription] = useState('');
  const [recConsumoDiario, setRecConsumoDiario] = useState({});
  const [resultadoExame, setResultadoExame] = useState({});
  const [viewDescription, setViewDescription] = useState(false);
  const [examesList, setExamesList] = useState([])
  const [faixaEtariaList, setFaixaEtariaList] = useState([])
  const [exameSelecionado, setExameSelecionado] = useState("")
  const [faixaEtaria, setFaixaEtaria] = useState({});
  const [dataExame, setDataExame] = useState({});
  const [open, setOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [userId, setUserId] = useState("")
  const [historicoExames, setHistoricoExames] = useState([])
  const [selectedFilter, setSelectedFilter] = useState("Todos")
  const [loadingFilter, setLoadingFilter] = useState(false)
  const [examResultText, setExamResultText] = useState("")

  useEffect(() => {
    const userId = localStorage.getItem('userId')
    if (!userId) {
      navigate('/login', { replace: true })
    }
    setUserId(userId)
    const loadExame = async (id) => {
      await getExames(id)
        .then(response => {
          console.log(response)
          setExamesList(response)
          return response
        })
        .catch(function (error) {
          console.log(error)
          return []
        });
    }
    console.log('CADASTRO')
    // localStorage.removeItem('doenca')
    // localStorage.removeItem('nutrientes')

    var doenca = JSON.parse(localStorage.getItem('doenca'))
    setDoencaSaved(doenca)
    if (doenca != null) {
      setRealizouCadastroDoenca(true)
      loadExame(doenca.doencaId)
    }

    var nutrientes = JSON.parse(localStorage.getItem('nutrientes'))
    setNutrientesSaved(nutrientes)

    const loadRegistrosExames = async (id) => {
      await getRegistroExames(userId).then(async (response) => {
        if (response) {
          setHistoricoExames(response)
        }
      }).catch(error => {
        console.log(error)
        if (error == 404) {
          setErrorMessage("Você precisa cadastrar um Exames para visualizar relatórios")
          setOpen(true)
        } else {
          setErrorMessage("Erro ao carregar grafico, tente novamente mais tarde")
          setOpen(true)
        }
      })
    }

    loadRegistrosExames()
  }, [])

  const onClickBack = () => {
    navigate('/', { replace: true });
  }

  const handleOpenModal = () => {
    setOpenModal(true);
    loadDoencas();
  }

  const handleOpenModalExames = (id, name) => {
    setFaixaEtaria({})
    setOpenModalExames(true);
    setExameSelecionado(name)
    loadExamesFaixaEtaria(id);
  }
  const handleCloseModal = () => setOpenModal(false);
  const handleCloseModalExames = () => setOpenModalExames(false);

  const loadDoencas = async () => {
    await getDoencas()
      .then(response => {
        setDoeancasList(response)
      })
      .catch(function (error) {
        console.log(error)
      });
  }

  const loadNutrientes = async (id) => {
    await getNutrientes(id)
      .then(response => {
        setNutrientesList(response)
      })
      .catch(function (error) {
        console.log(error)
      });
  }

  const handleChange = (event) => {
    setDoenca(event.target.value);
    setDescription(event.target.value.descricao)
    loadNutrientes(event.target.value.doencaid)
  };

  const handleChangeFaixaEtaria = (event) => {
    setFaixaEtaria(event.target.value);
  };

  const handleChangeRecomendacao = (value, item) => {
    let recs = recConsumoDiario
    recs[item.nutrienteid] = value
    setRecConsumoDiario(recs)
  };

  const isLetters = (str) => /^[A-Za-z]*$/.test(str);

  const handleChangeResultado = (value, item) => {
    let result = resultadoExame
    console.log(value)
    if (!isLetters(value)) {
      console.log(value)
      result[item.exameid] = value
      setResultadoExame(result)
      console.log(value)
      setExamResultText(value)
    }
  };

  const saveDoenca = async () => {
    let doencaData = {
      'doencaId': doenca.doencaid,
      'nome': doenca.nome
    }

    let error = false
    var nutrientesData = nutrientesList.map(function (item, i) {
      if (!recConsumoDiario[item.nutrienteid]) {
        error = true
      }
      return {
        'nutrienteid': item.nutrienteid,
        'quantidade': recConsumoDiario[item.nutrienteid],
        'nome': item.nome
      }
    })
    if (error) {
      setErrorMessage("Preencha todos os campos")
      setOpen(true)
    } else {
      await createDiagnostico(doenca.doencaid, nutrientesData, userId).then(response => {
        localStorage.setItem('doenca', JSON.stringify(doencaData))
        localStorage.setItem('nutrientes', JSON.stringify(nutrientesData))
        handleCloseModal()
        loadExames()
        window.location.reload()
      }).catch(error => {
        console.log(error)
        setErrorMessage("Erro ao cadastrar diagnostico, tente novamente mais tarde")
        setOpen(true)
      })
    }

  }

  const saveExame = async () => {

    if (Object.keys(faixaEtaria).length == 0 || Object.keys(dataExame).length == 0 || !resultadoExame[faixaEtaria.exameid]) {
      setErrorMessage("Preencha todos os campos")
      setOpen(true)
    } else {
      if (examResultText != "") {
        const month = dataExame.$d.getMonth() + 1
        const date = dataExame.$y + "-" + month + "-" + dataExame.$D

        await createRegistroExame(faixaEtaria.exame_faixaid, faixaEtaria.doencaid, userId, faixaEtaria.exameid, resultadoExame[faixaEtaria.exameid], date, faixaEtaria.referencia_inicial, faixaEtaria.referencia_final).then(results => {
          handleCloseModalExames()
          window.location.reload()
        }).catch(error => {
          console.log(error)
          setErrorMessage("Erro ao exame diagnostico, tente novamente mais tarde")
          setOpen(true)
        })
      } else {
        setErrorMessage("Preencha o campo de resultado apenas com numeros")
        setOpen(true)
      }
      console.log("completo")
    }
  }

  const loadExames = async (id) => {
    await getExames(id)
      .then(response => {
        setExamesList(response)
        return response
      })
      .catch(function (error) {
        console.log(error)
        return []
      });
  }

  const loadExamesFaixaEtaria = async (id) => {
    await getExameFaixaEtaria(doencaSaved.doencaId, id)
      .then(response => {
        setFaixaEtariaList(response)
        return response
      })
      .catch(function (error) {
        console.log(error)
        return []
      });
  }

  const handleChangeDate = (newValue) => {
    setDataExame(newValue)
  }

  const fullDescription = () => setViewDescription(!viewDescription)

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const formatData = (data) => {
    const date = new Date(data)
    const dia = date.getDate()
    const mes = date.getMonth() + 1
    const ano = date.getFullYear()
    return dia + "/" + mes + "/" + ano
  }

  function timeout(delay) {
    return new Promise(res => setTimeout(res, delay));
  }

  const handleFilter = async (event) => {
    setLoadingFilter(true)
    setSelectedFilter(event.target.defaultValue)
    await timeout(1000).then(() => {
      setLoadingFilter(false)
    })
  }
  return (
    <div className='cadastrarExame'>
      <Row>
        <Col span={24} className='cadastrarExame__header'>
          <ArrowLeftOutlined className='cadastrarExame__icons' onClick={onClickBack} />
          <img src={ExamesIcon} alt='' className='cadastrarExame__logo' />
          <p className='cadastrarExame__title'>Cadastrar Exames</p>
        </Col>
      </Row>
      <div className="cadastrarExame__calendar">
        {
          realizouCadastroDoenca ?
            <div className="cadastrarExame__cadastro">
              <div className="cadastrarExame__cadastroTitle">Exames para seu diagnóstico</div>
              {
                examesList.map(function (item, i) {
                  return (
                    <div className="cadastrarExame__grid-item" onClick={() => handleOpenModalExames(item.exameid, item.nome)}>
                      <div className="cadastrarExame__itemDescription">{item.nome}</div>
                    </div>
                  )
                })
              }

              <div className="cadastrarExame__cadastroTitle">Seu histórico de Exames</div>
              <FormControl className="cadastrarExame__filter">
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  size="small"
                  defaultValue="Todos"
                >
                  {
                    examesList.map((row) => {
                      return (
                        <FormControlLabel value={row.nome} control={<Radio />} label={row.nome} onChange={(val) => handleFilter(val)} />
                      )
                    })
                  }
                  <FormControlLabel
                    value="Todos"
                    control={<Radio />}
                    label="Todos"
                    onChange={(val) => handleFilter(val)}
                  />
                </RadioGroup>
              </FormControl>
              {
                loadingFilter ?
                  <div>
                    <CircularProgress />
                  </div>
                  :
                  <div className='cadastrarExame__historico'>
                    <TableContainer>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Nome do Exame</TableCell>
                            <TableCell align="right">Data</TableCell>
                            <TableCell align="right">Resultado</TableCell>
                            <TableCell align="right">Valor de Referência</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {historicoExames.map((row) => {
                            if (row.nome == selectedFilter || selectedFilter == "Todos") {
                              return (
                                <TableRow
                                  key={row.nome}
                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    {row.nome}
                                  </TableCell>
                                  <TableCell align="right">{formatData(row.dataexame)}</TableCell>
                                  <TableCell align="right">{row.resultado} mg/dL</TableCell>
                                  <TableCell align="right">{row.referencia_inicial} a {row.referencia_final} mg/dL</TableCell>
                                </TableRow>
                              )
                            }
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
              }




            </div>
            :
            <div className='cadastrarExame__warn'>
              Você ainda não realizou cadastro de um Diagnóstico
              <div className='cadastrarExame__cardInserirDoenca' onClick={() => handleOpenModal()}>
                Cadastrar Diagnóstico
              </div>
            </div>
        }
      </div>

      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>{errorMessage}</Alert>
      </Snackbar>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h2>Cadastro de Diagnóstico</h2>
          <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="demo-simple-select-standard-label">Doença</InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={doenca}
              onChange={handleChange}
              label="Doença"
            >
              {
                doeancasList.map(function (item, i) {
                  return (
                    <MenuItem value={item}>
                      <em>{item.nome}</em>
                    </MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>
          {
            doenca.descricao != undefined &&
            <div onClick={fullDescription} style={{ fontSize: 12, marginTop: -10 }}> {viewDescription ? <p>{description}</p> : <p>{description.substring(0, 103)}... <br></br> <b>ver mais</b></p>}</div>
          }
          {
            JSON.stringify(doenca) != '{}' &&

            <div>
              <h4 style={{ marginBottom: -10 }}>Nutrientes Controlados:</h4>
              {
                nutrientesList.map(function (item, i) {
                  return (
                    item.nome == 'Proteína' ?
                      <div>
                        <h5>{item.nome}</h5>
                        <TextField id={item.nutrienteid} onChange={(event) => handleChangeRecomendacao(event.target.value, item)} label="Recomendação diária" type="number" variant="standard" style={{ marginTop: -20, marginBottom: 5, width: 120 }} />g
                      </div>
                      :
                      <div>
                        <h5>{item.nome}</h5>
                        <TextField id={item.nutrienteid} onChange={(event) => handleChangeRecomendacao(event.target.value, item)} label="Recomendação diária" type="number" variant="standard" style={{ marginTop: -20, marginBottom: 5, width: 120 }} />mg
                      </div>
                  )
                })
              }
            </div>
          }
          <div className='diario__cardInserirDoenca' onClick={() => saveDoenca()}>
            Salvar
          </div>
        </Box>
      </Modal>

      <Modal
        open={openModalExames}
        onClose={handleCloseModalExames}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h2>Cadastro {exameSelecionado}</h2>
          <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="demo-simple-select-standard-label">Faixa Etária</InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={faixaEtaria}
              onChange={handleChangeFaixaEtaria}
              label="Faixa Etária"
            >
              {
                faixaEtariaList.map(function (item, i) {
                  return (
                    <MenuItem value={item}>
                      <em>{item.faixa_etaria}</em>
                    </MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>
          {
            faixaEtaria.valor_referencia != undefined &&
            <div>
              <div>Valor de Referência: {faixaEtaria.valor_referencia} </div>
              <TextField
                id="input-with-sx"
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
                label="Resultado Exame"
                onChange={(event) => handleChangeResultado(event.target.value, faixaEtaria)}
                variant="standard"
                style={{ marginTop: 20, width: 200 }}
              />

              {/* <TextField id={faixaEtaria.exame_faixaid} onChange={(event) => handleChangeResultado(event.target.value, faixaEtaria)} label="Resultado Exame" value={examResultText} variant="standard" style={{ marginTop: 20, width: 200 }} /> */}

              <div style={{ marginTop: 30 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <MobileDatePicker
                    label="Data do Exame"
                    inputFormat="DD/MM/YYYY"
                    value={dataExame}
                    onChange={handleChangeDate}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </div>
            </div>
          }
          <div className='diario__cardInserirDoenca' onClick={() => saveExame()}>
            Salvar
          </div>
        </Box>
      </Modal>
    </div>
  )
}

export default CadastrarExames
